import { BASE_API } from "../utils/constants";
import { authHeader } from "./token";

// Caja (app `cashbox` del backend). Todo requiere sesión de staff.
async function request(path, token, options = {}) {
  const response = await fetch(`${BASE_API}/api/cash-sessions/${path}`, {
    ...options,
    headers: {
      ...authHeader(token),
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result?.detail || "Error en la caja");
  return result;
}

export const getCurrentCashApi = (token) =>
  request("current/", token).then((result) => result.session);

export const getCashSessionsApi = (token) => request("", token);

export const openCashApi = (openingAmount, token) =>
  request("open/", token, {
    method: "POST",
    body: JSON.stringify({ opening_amount: openingAmount }),
  });

export const addCashMovementApi = (id, movement, token) =>
  request(`${id}/movement/`, token, {
    method: "POST",
    body: JSON.stringify(movement),
  });

// Solo Admin: anula un ingreso/egreso registrado por error (con motivo).
export const voidCashMovementApi = (id, movementId, reason, token) =>
  request(`${id}/void-movement/`, token, {
    method: "POST",
    body: JSON.stringify({ movement: movementId, reason }),
  });

export const closeCashApi = (id, countedAmount, notes, token) =>
  request(`${id}/close/`, token, {
    method: "POST",
    body: JSON.stringify({ counted_amount: countedAmount, notes }),
  });
